
import MeetingCenter from './src/MeetingCenter'

const global = window || {};

const ZJMeeting = {
    MeetingCenter
};

const install = function(Vue, opts) {
    global.ZJMeeting = ZJMeeting;
    MeetingCenter.install(Vue, opts);
};

export default {
    install,
    ...ZJMeeting
};